class ShildnAnimationSteps extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    if (!('IntersectionObserver' in window)) {
      this.classList.add('play');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.remove('play');
            void this.offsetWidth;
            this.classList.add('play');
          } else {
            this.classList.remove('play');
          }
        });
      },
      { rootMargin: '0px 0px -80px 0px', threshold: 0.25 }
    );
    observer.observe(this);
  }
}

customElements.define('shildn-animation-steps', ShildnAnimationSteps);
